import axios from 'axios';
/**
 * 获取套餐列表
 * @param {object} params
 * @param {string} params.ShopId 店铺ID
 * @param {string} params.PackageName 套餐名称
 * @returns 
 */
export function getPackageListApi(params) {
  return axios({
    url: "https://interface2.visumall.com/Product/ProductPackage.ashx?cmd=GetList",
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify({
      token: {
        sToken: "E0B1486293C779EEE7CD24AF277703D7",
      },
      SearchCondition: {
        ShopId: params.ShopId,
        PackageName: params.PackageName
      }
    })
  })
}

/**
 * 获取套餐详情
 * @param {object} params
 * @param {string} params.PackageId 套餐id
 * @param {string} params.ShopId 门店id
 * @returns 库存：Result.DetailItem.ProductItems.Amount， 单价：Result.DetailItem.ProductItems.ProductOfficalPrice 
 */
export function getPackageDetailApi(params) {
  return axios({
    url: "https://interface2.visumall.com/Product/ProductPackage.ashx?cmd=GetProduct",
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify({
      token: {
        sToken: "E0B1486293C779EEE7CD24AF277703D7",
      },
      SearchCondition: {
        PackageId: params.PackageId,
        ShopId: params.ShopId || '55C4D225-230C-4C91-8981-376145E44101',
      }
    })
  })
}

/**
    * 添加购物车
    * @param {object} params
    * @param {string} params.CHPProductId 商品id
    * @param {string} params.CHPProductSortGroup 商品分组
    * @param {number} params.CHPAmount 数量
    * @param {number} params.CHPPrice 价格
    * @param {string} params.CHPExpertId 专家id
    * @param {string} params.CHPChooseId 购物车id
    * @returns {Promise} 添加购物车结果
    * */
export function addToCartApi(params) {
  return axios({
    url: "https://interface2.visumall.com/Customer/ChooseProduct.ashx?cmd=Insert",
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify(
      {
        token: {
          sToken: "E0B1486293C779EEE7CD24AF277703D7",
          TimeSpan: "1574670974"
        },
        o: {
          CHPChooseId: params.CHPChooseId,
          CHPProductId: params.CHPProductId,
          CHPAmount: params.CHPAmount,
          CHPS_OP_ALL_Id: "00000000-0000-0000-0000-000000000000",
          CHPLeftRightEyes: "",
          CHPProductSortGroup: params?.CHPProductSortGroup,
          CHPPrescriptionData: "",
          CHPPrice: params?.CHPPrice,
          CHPExpertId: params.CHPExpertId,
        },
        from: "vp_order",
        lang: "cn"
      }
    ),
  })
}

/**
 * 批量加入购物车
 * @param {*} params 参数对象 
 * @returns 
 */
export function batchAddCartApi(params) {
  return axios({
    url: "https://interface2.visumall.com/Customer/ChooseProduct.ashx?cmd=InsertList",
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify(
      {
        token: {
          sToken: "E0B1486293C779EEE7CD24AF277703D7",
          TimeSpan: "1574670974"
        },
        lo: params,
        from: "vp_order",
        lang: "cn"
      }
    ),
  })
}

/**
 * 获取购物车列表
 * @param {object} params
 * @param {string} params.ChooseId 咨询id
 * @param {string} params.ShopId 门店id
 * @returns 
 */
export function getCartListApi(params) {
  return axios({
    url: "https://interface2.visumall.com/Customer/ChooseProduct.ashx?cmd=GetList",
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify(
      {
        token: {
          sToken: "E0B1486293C779EEE7CD24AF277703D7",
          TimeSpan: "1574670974"
        },
        SearchCondition: {
          IndexMin: 0,
          IndexMax: 0,
          ChooseId: params.ChooseId,
          ShopId: params.ShopId,
          CHPStatus: "1",
          ProductSource: 'package'
        },
        ReturnInfo: {
          S_OP_ALL: 1,
          ProductRelation: {
            Product: {},
            ShopProduct: 1
          }
        },
        from: "vp_order",
        lang: "cn"
      }
    )
  })
}

/**
 *  修改购物车产品
 * @param {*} params 元对象参数对象
 * @returns 
 */
export function updateCartProductApi(params) {
  return axios({
    url: 'https://interface2.visumall.com/Customer/ChooseProduct.ashx?cmd=Update',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify(
      {
        token: {
          sToken: "E0B1486293C779EEE7CD24AF277703D7",
          TimeSpan: "1574670974"
        },
        o: params,
        from: "vp_order",
        lang: "cn"
      }
    )
  })
}

/**
 * 修改购物车产品镜片直径
 * @param {object} params
 * @param {string} params.ChooseProductId 购物车商品id
 * @param {string} params.PrescriptionId 镜片直径id
 * @param {string} params.CHPLeftRightEyes 左右眼
 * @param {string} params.SetLensDia 镜片直径
 */
export function updateCartProductLensDiameterApi(params) {
  return axios({
    url: 'https://interface2.visumall.com/Customer/ChooseProduct.ashx?cmd=UpdateLensDia',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify(
      {
        token: {
          sToken: "E0B1486293C779EEE7CD24AF277703D7",
          TimeSpan: "1574670974"
        },
        o: {
          ChooseProductId: params.ChooseProductId,
          CHPS_OP_ALL_Id: params.PrescriptionId,
          CHPLeftRightEyes: params.CHPLeftRightEyes,
          SetLensDia: params.SetLensDia
        }
      }
    )
  })
}

/**
   * 修改购物车产品镜片长度
   * @param {object} params
   * @param {string} params.ChooseProductId 购物车商品id
   * @param {string} params.PrescriptionId 镜片长度id
   * @param {string} params.CHPLeftRightEyes 左右眼
   * @param {string} params.SetLensChannelLength 镜片长度
   */
export function updateCartProductLensChannelApi(params) {
  return axios({
    url: 'https://interface2.visumall.com/Customer/ChooseProduct.ashx?cmd=UpdateLensChannelLength',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify(
      {
        token: {
          sToken: "E0B1486293C779EEE7CD24AF277703D7",
          TimeSpan: "1574670974"
        },
        o: {
          ChooseProductId: params.ChooseProductId,
          CHPS_OP_ALL_Id: params.PrescriptionId,
          CHPLeftRightEyes: params.CHPLeftRightEyes,
          SetLensChannelLength: params.SetLensChannelLength
        }
      }
    )
  })
}

/**
 * 删除购物车产品
 * @param {string} ChooseProductId 购物车商品id
 */
export function deleteCartProductApi(ChooseProductId) {
  return axios({
    url: 'https://interface2.visumall.com/Customer/ChooseProduct.ashx?cmd=DeleteById',
    method: "post",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify(
      {
        token: {
          sToken: "E0B1486293C779EEE7CD24AF277703D7",
          TimeSpan: "1574670974"
        },
        ChooseProductId: ChooseProductId,
        from: "3d_cart_order",
        lang: "cn"
      }
    )
  })
}

//提交订单
export function submitOrderApi(params) {
  return axios({
    url: 'https://interface2.visumall.com/Customer/CustomerOrder.ashx?cmd=Insert',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify({
      token: {
        TimeSpan: Date.now(),
        sToken: "e2b2c2d2-1a2b-4c2d-8e2f-1a2b3c4d5e6f",
      },
      o: params,
      PaperCouponNo: params.PaperCouponNo,
      PaperCouponPrice: params.PaperCouponPrice
    })
  })
}

/**
 * 处方列表
 * @param {string} chooseId 咨询id
 * @returns 处方列表
 */
export function getPrescriptionListApi(chooseId) {
  return axios({
    url: 'https://interface2.visumall.com/Customer/S_OP_ALL.ashx?cmd=GetList',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify({
      token: {
        TimeSpan: Date.now(),
      },
      SearchCondition: {
        S_OP_Type: 'Inspection',
        ChooseId: chooseId,
        S_OP_Model: 'S_OP_IO',
      },
      isCreatIO: 0,
      from: "vp_order",
      lang: "cn"
    })
  })
}

/**
 * 获取ok镜处方
 * @param {string} chooseId 咨询Id
 * @returns 
 */
export function getOkPrescriptionApi(chooseId) {
  return axios({
    url: 'https://interface2.visumall.com/Customer/S_OP_ALL.ashx?cmd=GetCLIOList',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: JSON.stringify({
      token: {
        TimeSpan: Date.now(),
      },
      SearchCondition: {
        ChooseId: chooseId
      }
    })
  })
}